<template>
  <modal
    class="successfulSignUpModal"
    name="successfulSignUpModal"
    transition="pop-out"
    :width="850"
    :height="450"
    @opened="opened"
    @before-close="beforeclose"
  >
    <div>
      <div class="successful_emoji">
        <img src="https://eterna.epump.ng/img/1_Thumbs_up_05.46566c09.png" />
      </div>
      <div class="successful_text">
        <h4>{{ $t("text.successSUmodal.desc") }}</h4>
        <p>{{ $t("text.successSUmodal.desc1") }}</p>
      </div>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 850;

export default {
  name: "successfulSignUpModal",
  props: [],
  data() {
    return {};
  },
  mounted() {},
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    opened() {
      `thanks for everything ${this.name}`;
    },
    beforeclose() {},
  },
};
</script>
